export var ConfigurationStatus;
(function (ConfigurationStatus) {
    ConfigurationStatus["CONFIGURATION_STATUS_INITIAL_CLASSIFICATION"] = "INITIAL_CLASSIFICATION";
    ConfigurationStatus["CONFIGURATION_STATUS_ACCESS_LOST"] = "ACCESS_LOST";
    ConfigurationStatus["CONFIGURATION_STATUS_CLASSIFICATION_FAILED"] = "CLASSIFICATION_FAILED";
    ConfigurationStatus["CONFIGURATION_STATUS_UNASSIGNED"] = "UNASSIGNED";
    ConfigurationStatus["CONFIGURATION_STATUS_ASSIGNED"] = "ASSIGNED";
    ConfigurationStatus["CONFIGURATION_STATUS_TERMINATED"] = "TERMINATED";
    ConfigurationStatus["CONFIGURATION_STATUS_DISCONNECTED"] = "DISCONNECTED";
    ConfigurationStatus["CONFIGURATION_STATUS_EXCLUDED_FROM_BACKUP"] = "EXCLUDED_FROM_BACKUP";
    ConfigurationStatus["CONFIGURATION_STATUS_LIMIT_EXCEEDED"] = "LIMIT_EXCEEDED";
    ConfigurationStatus["CONFIGURATION_STATUS_UNSUPPORTED"] = "UNSUPPORTED";
})(ConfigurationStatus || (ConfigurationStatus = {}));
